import PropTypes from 'prop-types'

import styles from './OtaBuster.module.scss'

function ClockIcon() {
  return (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" aria-hidden="true">
      <circle cx="6.5" cy="6.5" r="5.25" stroke="currentColor" strokeWidth="1.2" />
      <path d="M6.5 3.75V6.5l2 1.25" stroke="currentColor" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  )
}

function TimingControl({ label, editable, daysValue, onDaysChange, onClick }) {
  return (
    <div className={styles.timingControl}>
      <div className={styles.timingConnectorTop} aria-hidden="true" />
      <div className={styles.timingBar}>
        <ClockIcon />
        <button type="button" className={styles.timingLabelButton} onClick={onClick}>
          {label}
        </button>
        {editable && (
          <div className={styles.timingInputs}>
            <input
              type="number"
              min="1"
              max="14"
              className={styles.timingAmountInput}
              value={daysValue}
              onChange={event => onDaysChange(Number(event.target.value))}
              aria-label="Delay amount"
            />
            <span className={styles.timingUnitSelect}>Days</span>
          </div>
        )}
      </div>
      <div className={styles.timingConnectorBottom} aria-hidden="true" />
    </div>
  )
}

TimingControl.propTypes = {
  label: PropTypes.string.isRequired,
  editable: PropTypes.bool,
  daysValue: PropTypes.number,
  onDaysChange: PropTypes.func,
  onClick: PropTypes.func
}

TimingControl.defaultProps = {
  editable: false,
  daysValue: 1,
  onDaysChange: undefined,
  onClick: undefined
}

export default TimingControl
